/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export const VITAL_NAMES = {
  FIRST_PAINT: 'fp',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_INTERACTION: 'fi',
  LARGEST_CONTENTFUL_PAINT: 'lcp',
  LOAD_TIME: 'load',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  INTERACTION_TO_NEXT_PAINT: 'inp',
  TIME_TO_FIRST_BYTE: 'ttfb'
};